import { createFileRoute, useRouter } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { Button, LinkButton } from "@/globalComponents/atoms/Button"
import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"
import { useScopedNavigate } from "@/utilities/hooks/useScopedRouting"
import { useTheme } from "@/utilities/hooks/useTheme"

export const Route = createFileRoute("/auth/")({
  component: RouteComponent,
})

function RouteComponent() {
  const search = Route.useSearch()
  const { t } = useTranslation(["gated", "common"])
  const scopedNavigate = useScopedNavigate()
  const router = useRouter()

  const locationName = useTheme().locationInformation?.locationName

  const authRequired = search.conversionFlow?.startsWith("required")

  return (
    <>
      <Heading level={1} as={1}>
        {t("auth.index.heading", { ns: "common" })}
      </Heading>
      <Text level={2} style={{ marginTop: "var(--space-2)" }}>
        {authRequired && locationName
          ? t("common:auth.index.descriptionRequired", { locationName })
          : locationName
            ? t("common:auth.index.descriptionWithLocation", { locationName })
            : t("auth.index.descriptionGeneric", { ns: "common" })}
      </Text>
      <div>
        <LinkButton
          buttonType="primary"
          to="/auth/create-account"
          search={search}
          style={{ marginBottom: "var(--space-3)" }}
        >
          {t("auth.index.createAccount", { ns: "common" })}
        </LinkButton>
        <LinkButton buttonType="default" to="/auth/sign-in" search={search}>
          {t("auth.index.signIn", { ns: "common" })}
        </LinkButton>
      </div>

      {!authRequired && search.conversionFlow && (
        <Text level={2} style={{ display: "flex", justifyContent: "center" }}>
          <Button
            buttonType="primary"
            presentation="link"
            onPress={() => {
              // Normal redirect flow when no guest data or on error
              if (search.redirect) {
                router.history.push(search.redirect)
              } else {
                scopedNavigate({ to: "/" })
              }
            }}
          >
            {t("common.skipForNow", { ns: "common" })}
          </Button>
        </Text>
      )}
    </>
  )
}
